import moment from "moment";
export default {
    methods: {
      getDateBefore(dayNumber) {
        const currDate = new Date();
        return new Date(currDate.getTime() - dayNumber * 24 * 60 * 60 * 1000);
      },
      isActiveDate(startDate, endDate) {
        const currDate = new Date().getTime();
        return new Date(startDate).getTime() <= currDate 
               && new Date(endDate).getTime() >= currDate;
      },
      getYearArray(startYear) {
        startYear =  startYear || 1980;
        const currentYear = new Date().getFullYear();
        const years = [];
        for(let i = startYear; i <= currentYear; i++){
          years.push(i);
        }
        years.reverse();
        return years;
      },
       formatUnix (value) {
        if (value) {
          return typeof value === 'number' ? moment(value, 'x').local().format('DD/MM/YYYY') : moment(value).local().format('DD/MM/YYYY')
        }
      }
    }
  };
  